import React from 'react';
import DadaLogo from '../../assets/images/dada-logo-small.svg';
import './index.scss';

const ResponsiveLogo = () => (
  <div className="responsiveLogo">
    <img src={DadaLogo} alt="dada logo" />
  </div>
);

export default (ResponsiveLogo);



// WEBPACK FOOTER //
// ./src/components/LogoComponent/index.js